import {Component, ViewEncapsulation} from "@angular/core";
import {MatDialog, MatDialogRef} from "@angular/material";

@Component({
  selector: 'close-dialog',
  templateUrl: './close-dialog.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class CloseDialogComponent {
  constructor(private dialog: MatDialog,
              private dialogRef: MatDialogRef<CloseDialogComponent>) {
  }

  close():void {
    this.dialog.closeAll();
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/components/form-viewer/close-dialog/close-dialog.component.ts